import request from '@/utils/request'

export function getBalance(data) {
  return request({
    url: '/Api/brand.Recharge/getBalance',
    method: 'post',
    data
  })
}

export function pay(data) {
  return request({
    url: '/Api/brand.Recharge/pay',
    method: 'post',
    data
  })
}
export function getAccountData(data) {
  return request({
    url: '/Api/brand.Account/index',
    method: 'post',
    data
  })
}
export function getAccountLog(data) {
  return request({
    url: '/Api/brand.Account/in_out_list',
    method: 'post',
    data
  })
}


export function getRechargeLog(data) {
  return request({
    url: '/Api/brand.Account/rechargeLog',
    method: 'post',
    data
  })
}

export function getBillList(data) {
  return request({
    url: '/Api/brand.Account/getBill',
    method: 'post',
    data
  })
}

export function downloadBill(data) {
  return request({
    url: '/Api/brand.Account/downloadBill',
    method: 'post',
	responseType:'blob',
    data
  })
}